import React from 'react';
import { Link } from 'react-router-dom';
import SeriesHeader from '../components/brand/SeriesHeader';
import SeriesFooter from '../components/brand/SeriesFooter';
import ClarityHero from '../components/clarity/ClarityHero';
import HowItHelps from '../components/clarity/HowItHelps';
import RelatableSituations from '../components/clarity/RelatableSituations';
import ClarityDemo from '../components/clarity/ClarityDemo';
import ValueBuild from '../components/clarity/ValueBuild';
import SeriesPricing from '../components/series/SeriesPricing';
import { getSeriesBySlug } from '../data/series';

const ClarityPage = () => {
  // Use IT Leadership series for branding/pricing
  const series = getSeriesBySlug('it-leadership') || {
    name: '30 Day Skills',
    accentColor: '#dc2626',
    slug: 'it-leadership'
  };

  return (
    <div className="clarity-page min-h-screen bg-stone-50">
      <SeriesHeader series={series} />
      
      <main>
        {/* Hero with embedded input */}
        <ClarityHero series={series} />
        
        {/* How it helps - 3 steps */}
        <HowItHelps series={series} />
        
        {/* Relatable situations grid */}
        <RelatableSituations series={series} />
        
        {/* Interactive demo chat */}
        <ClarityDemo series={series} />
        
        {/* Value build - what happens over time */}
        <ValueBuild series={series} />
        
        {/* Existing pricing section */}
        <SeriesPricing series={series} />
      </main>
      
      <SeriesFooter series={series} />
    </div>
  );
};

export default ClarityPage;
